import { ProgrammeMember } from './programmeMember';
import { ProgrammeCourse } from './programmeCourse';

export class Programme {
    id: number;
    name: string;
    owner_id: number;
    members: ProgrammeMember[];
    courses: ProgrammeCourse[];
    type: string;
    start_date:any;
    close_date:any;
    status:any;
    constructor(programme?) {
        if (programme) {
            this.id = programme.id;
            this.name = programme.name;
            this.owner_id = programme.owner_id;
            this.members = programme.members;
            this.courses = programme.courses;
            this.type=programme.type;
            this.start_date=programme.start_date;
            this.close_date=programme.close_date;
            this.status=programme.status;
        }
    }
}
